import React, { memo, useEffect, useRef, useState } from 'react';
import { css } from 'linaria';
import { useSelector } from 'react-redux';
import { Loader, Typography, RegularButton } from 'fronton-react';
import { useMediaQuery } from 'react-responsive';
import { styled } from 'linaria/react';
import { getCustomerId } from 'domains/configurator/store/selectors';
import { getPageModel } from 'domains/pageModel/store/selectors';
import { MobileStub } from 'common/icons/mobile-stub';
import { getConfiguratorURL, getCookies } from 'common/store/selectors';
import { storageSessionKey } from 'consts';
import { useAuthMessage, useLocalStorage, useRefresh } from './frame.hooks';

const departmentId = '14';

export const PageComponent: React.FC<{}> = memo(() => {
  const customerId = useSelector(getCustomerId);
  const pageModel = useSelector(getPageModel);
  const configuratorURL = useSelector(getConfiguratorURL);
  const cookies = useSelector(getCookies);

  const [sessionId] = useLocalStorage(storageSessionKey);

  const ref = useRef(null);
  const [url, setUrl] = useState<URL | null>(null);
  const regionId = pageModel?.properties?.regionId ?? cookies?._regionID;

  useEffect(() => {
    const baseUrl = new URL(configuratorURL);
    const { search } = window.location;
    const parameters = new URLSearchParams(search);
    const configurationId = parameters.get('configurationId');

    const params = {
      regionId,
      customerId,
      sessionId,
      departmentId,
      creatorType: 'customer',
      configurationId,
    };
    Object.keys(params).forEach(param => {
      // eslint-disable-next-line @typescript-eslint/ban-ts-comment
      // @ts-ignore
      if (params[param]) {
        // eslint-disable-next-line @typescript-eslint/ban-ts-comment
        // @ts-ignore
        baseUrl.searchParams.set(param.toString(), params[param]);
      }
    });
    if (!url) {
      setUrl(baseUrl);
    }
  }, [regionId, customerId, sessionId, url, configuratorURL]);

  const { iframeState } = useAuthMessage();

  useRefresh({ configuratorURL, setUrl, iframeState });

  useEffect(() => {
    if (iframeState.state === 'refresh') {
      const refreshURL = new URL(`${configuratorURL}${iframeState.queryParam}`);
      setUrl(refreshURL);
    }
  }, [configuratorURL, setUrl, iframeState.state, iframeState.queryParam]);

  const isDesktop = useMediaQuery({
    query: '(min-width: 1024px)',
  });

  if (!url) {
    return (
      <Waiting>
        <Loader />
      </Waiting>
    );
  }

  if (!isDesktop) {
    return (
      <MobileStubContainer>
        <MobileStub />
        <MobileInfoContainer>
          <Typography variant="h3" color="text-primary" style={{ textAlign: 'center' }}>
            3D-планировщик недоступен для мобильных устройств.
          </Typography>
          <Typography
            variant="s"
            color="text-primary"
            size="body_short"
            style={{ textAlign: 'center', marginTop: '16px' }}>
            Пожалуйста, воспользуйтесь персональным компьютером.
          </Typography>
          <RegularButton
            style={{ marginTop: '16px' }}
            onClick={() => {
              if (!__IS_SERVER__) {
                window.history.back();
              }
            }}>
            Вернуться назад
          </RegularButton>
        </MobileInfoContainer>
      </MobileStubContainer>
    );
  }

  return <iframe className={configuratorFrame} src={url?.toString()} title="ceramic3d" ref={ref} />;
});

const configuratorFrame = css`
  width: 100%;
  height: calc(100vh - 122px);
  border: none;

  @media (--only-mobile) {
    height: calc(100vh - 144px);
  }
`;

const Waiting = styled.div`
  display: flex;
  align-items: center;
  justify-content: center;
  height: calc(100vh - 122px);

  @media (--only-mobile) {
    height: calc(100vh - 144px);
  }
`;

const MobileStubContainer = styled.div`
  display: flex;
  flex-direction: column;
  align-items: center;
  margin: 16px 32px 16px 32px;
`;

const MobileInfoContainer = styled.div`
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  margin-top: var(--space-300);
`;
